import type {IModule} from '../../core/interfaces/module.ts';

class Tryon implements IModule{
    init() {
        console.log('tryon module');
    }
}

export default new Tryon();
